export default "__VITE_ASSET__5f0fe30c__"